import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackSearchRequests = (query, searchType = 'text', resultCount = null) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    search_query: query,
    search_type: searchType,
    query_length: query.length,
    result_count: resultCount,
    ...getEnvironmentData()
  };

  posthog.capture('request_search', eventData);
  track('request_search', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('Search', {
      search_string: query,
      content_type: 'product',
      content_name: 'request_search',
      content_id: 'search_requests'
    });
  }
}; 